import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Company } from './company';
import { HttpClient, HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/operator/catch';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class LoginService {
  private creditsUpdated = new Subject<string>();
  creditsUpdated$ = this.creditsUpdated.asObservable();

  private appURL: string = environment.apiUrl;
  private SMSTemplateTransactional: string = environment.getSMSTemplateTransactional;
  private SMSTemplatePromotional: string = environment.getSMSTemplatePromotional;
  private getSMSReport: string = environment.getSMSReport;
  private apiUrl_multi: string = environment.apiUrl_multi;
  private uploadURL: string = environment.uploadUrl;
  constructor(private http: HttpClient) { }
  login(customer) {
    return this.http.post(this.appURL + 'login', JSON.stringify({ customer: customer }));
  }
  register(user) {
    return this.http.post(this.appURL + 'signUp', JSON.stringify({ user: user }));
  }

  logout() {
    return this.http.get(this.appURL + 'logout');
  }
  session() {
    return this.http.get(this.appURL + 'session');
  }
  // Get Login user data from Localstorage
  getLocalSession(sessionData) {
    return localStorage.getItem(sessionData);
  }
  // Get Login user data from Localstorage
  setLocalSession(data, name) {
    localStorage.setItem(name, JSON.stringify(data));
    if (name === 'currentUser' && data.credits) {
      this.creditsUpdated.next(data.credits);
    }
  }


  getemployeeList(data, currentUser) {
    return this.http.post(this.appURL + 'getemployeeList', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  productsInService(currentUser) {
    return this.http.post(this.appURL + 'productsInService', JSON.stringify({ currentUser: currentUser }));
  }

  servicesInProduct(currentUser) {
    return this.http.post(this.appURL + 'servicesInProduct', JSON.stringify({ currentUser: currentUser }));
  }

  productReport(data, currentUser) {
    return this.http.post(this.appURL + 'productReport', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  productUsageReport(data, currentUser) {
    return this.http.post(this.appURL + 'productUsageReport', JSON.stringify({ data: data, currentUser: currentUser }));
  }


  getInvoiceReport(data, currentUser) {
    return this.http.post(this.appURL + 'getInvoiceReport', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  printBill(bill_no, customer_id, currentUser) {
    return this.http.post(this.appURL + 'printBill', JSON.stringify({ bill_no: bill_no, customer_id: customer_id, currentUser: currentUser }));
  }

  uploadResume(formData, empId, currentUser, uploadtype, email) {
    return this.http.post(this.uploadURL + 'upload.php?page=employee&empId=' + empId + '&currentUser='
      + currentUser + '&uploadtype=' + uploadtype + '&email=' + email, formData);
  }

  uploadproof(formData, secId, empId, currentUser, uploadtype) {
    return this.http.post(this.uploadURL + 'upload.php?page=sec3&secId=' + secId + '&empId='
      + empId + '&currentUser=' + currentUser + '&uploadtype=' + uploadtype, formData);
  }


  uploadFile(formData: any) {
    const headers = new HttpHeaders()
      // .set('Access-Control-Allow-Origin', `*`)
      // .set('Access-Control-Request-Headers', `Content-type,X-Requested-With,Origin,accept`)
      .set('Content-Type', `multipart/form-data`);
    return this.http.post(this.uploadURL + 'upload.php', formData, { headers }).subscribe();
  }

  uploadFile1(formData: any, name, upId, month, upField, tableName) {
    return this.http.post(this.uploadURL + 'upload.php?page=schedule_e&upname=' + name + '&upId=' + upId + '&month=' + month['getmonth'] + '&year=' + month['getyear'] + '&upField=' + upField + '&tableName=' + tableName, formData);
  }

  uploadFile2(formData: any, name, contId, month) {
    return this.http.post(this.uploadURL + 'upload.php?page=schedule_e&upname=' + name + '&contId=' + contId + '&month=' + month['getmonth'] + '&year=' + month['getyear'], formData);
  }

  uploadFile3(formData: any, name, tableName, document_name, description, uid) {
    return this.http.post(this.uploadURL + 'upload.php?page=document&upname=' + name + '&tableName=' + tableName + '&uid=' + uid + '&document_name=' + document_name + '&description=' + description, formData);
  }

  getDocuments(currentUser) {
    return this.http.post(this.appURL + 'getDocuments', JSON.stringify({ currentUser: currentUser }));
  }

  getCollectiveInventorySetup() {
    return this.http.post(this.appURL + 'getCollectiveInventorySetup', JSON.stringify({}));
  }

  getPartnershipCoupon(partnership_id, currentUser) {
    return this.http.post(this.appURL + 'getPartnershipCoupon', JSON.stringify({ partnership_id: partnership_id, currentUser: currentUser }));
  }

  movePreviousNextemp(subcont, n, tableName, currentUser) {
    return this.http.post(this.appURL + 'movePreviousNextemp', JSON.stringify({ subcont: subcont, n: n, tableName: tableName, currentUser: currentUser }));
  }

  Objtodate(obj) {
    if (obj.length != 0 && obj.day != '') {
      return obj.month + '/' + obj.day + '/' + obj.year;
    }
  }

  Objtodate1(obj) {
    if (!obj) return '';
    // If it's already a plain date string like "2026-04-01", return as-is
    if (typeof obj === 'string') return obj;
    // If it's a date picker object with .date property
    if (typeof obj === 'object' && obj.date && obj.date.day) {
      return obj.date.day + '/' + obj.date.month + '/' + obj.date.year;
    }
    return '';
  }

  Objecttodate(obj) {
    if (typeof obj === 'object' && obj) {
      const year = obj.year;
      const month = String(obj.month).padStart(2, '0');
      const day = String(obj.day).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } else {
      return '';
    }
  }

  getCurrentDate() {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1;
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return { date: { year: year, month: month, day: day } };
  }

  getCurrentDateString() {
    const dateObj = new Date();
    const paddedMonth = dateObj.getUTCMonth() + 1;
    const month = paddedMonth < 10 ? '0' + paddedMonth : paddedMonth.toString();

    const paddedday = dateObj.getUTCDate();
    const day = paddedday < 10 ? '0' + paddedday : paddedday.toString();
    const year = dateObj.getUTCFullYear();
    return year + '-' + month + '-' + day;
  }

  getCurrentMY() {
    const dateObj = new Date();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    return month + '/' + year;
  }
  getBlankDate() {
    return { date: { year: null, month: null, day: null } };
  }

  resetPassword(user) {
    return this.http.post(this.appURL + 'resetPassword', JSON.stringify({ user: user }));
  }

  getInventoryItem(inventory_item_id) {
    return this.http.post(this.appURL + 'getInventoryItem',
      JSON.stringify({ inventory_item_id: inventory_item_id }));
  }


  getCustomerList(data, currentUser) {
    return this.http.post(this.appURL + 'getcustomersList',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getMembershipReport(data, currentUser, type) {
    return this.http.post(this.appURL + 'getMembershipReport',
      JSON.stringify({ data: data, currentUser: currentUser, type: type }));
  }

  getOfferReport(data, currentUser) {
    return this.http.post(this.appURL + 'getOfferReport',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getPartnershipReport(data, currentUser) {
    return this.http.post(this.appURL + 'getPartnershipReport',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getCustomerPartnershipReport(data, currentUser) {
    return this.http.post(this.appURL + 'getCustomerPartnershipReport',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getservicecategory(service_category_id, type, currentUser) {
    return this.http.post(this.appURL + 'getservicecategory',
      JSON.stringify({ service_category_id: service_category_id, type: type, currentUser: currentUser }));
  }

  getAllCustomersList(currentUser) {
    return this.http.post(this.appURL + 'getAllCustomersList',
      JSON.stringify({ currentUser: currentUser }));
  }

  SyncMenuPrice(service_list_id, model, currentUser) {
    return this.http.post(this.appURL + 'SyncMenuPrice',
      JSON.stringify({ service_list_id: service_list_id, model: model, currentUser: currentUser }));
  }

  getProductsMap(currentUser) {
    return this.http.post(this.appURL + 'getProductsMap',
      JSON.stringify({ currentUser: currentUser }));
  }

  getemp(service_category_id, currentUser) {
    return this.http.post(this.appURL + 'getemp',
      JSON.stringify({ service_category_id: service_category_id, currentUser: currentUser }));
  }

  getBilliedService(service_category_id, currentUser) {
    return this.http.post(this.appURL + 'getBilliedService',
      JSON.stringify({ service_category_id: service_category_id, currentUser: currentUser }));
  }

  servicelist(service_category_id, customer_id, currentUser) {
    return this.http.post(this.appURL + 'servicelist',
      JSON.stringify({ service_category_id: service_category_id, customer_id: customer_id, currentUser: currentUser }));
  }

  delCheckout(customer_id, currentUser) {
    return this.http.post(this.appURL + 'delCheckout',
      JSON.stringify({ customer_id: customer_id, currentUser: currentUser }));
  }


  delCheckoutNew(customer_id, currentUser) {
    return this.http.post(this.appURL + 'delCheckoutNew',
      JSON.stringify({ customer_id: customer_id, currentUser: currentUser }));
  }

  getserviceoffered(service_offered_id, type, checkout, sorts, model, currentUser) {
    return this.http.post(this.appURL + 'getserviceoffered',
      JSON.stringify({ service_offered_id: service_offered_id, type: type, checkout: checkout, sorts: sorts, model: model, currentUser: currentUser }));
  }

  getRetailProductNew(search, currentUser) {
    return this.http.post(this.appURL + 'getRetailProductNew',
      JSON.stringify({ search: search, currentUser: currentUser }));
  }

  getRetailProduct(search, currentUser) {
    return this.http.post(this.appURL + 'getRetailProduct',
      JSON.stringify({ search: search, currentUser: currentUser }));
  }

  getBrand(currentUser) {
    return this.http.post(this.appURL + 'getBrand',
      JSON.stringify({ currentUser: currentUser }));
  }

  getINVService(currentUser) {
    return this.http.post(this.appURL + 'getINVService',
      JSON.stringify({ currentUser: currentUser }));
  }
  getProduct(currentUser) {
    return this.http.post(this.appURL + 'getProduct',
      JSON.stringify({ currentUser: currentUser }));
  }

  getScheduler(currentDateTime, currentDate, currentUser) {
    return this.http.post(this.appURL + 'getScheduler',
      JSON.stringify({ currentDateTime: currentDateTime, currentDate: currentDate, currentUser: currentUser }));
  }

  getschedulerList(service_category_id, date, model, currentUser) {
    return this.http.post(this.appURL + 'getschedulerList',
      JSON.stringify({ service_category_id: service_category_id, date: date, model: model, currentUser: currentUser }));
  }

  saveiservicecategory(company, currentUser) {
    return this.http.post(this.appURL + 'saveiservicecategory', JSON.stringify({ company: company, currentUser: currentUser }));
  }

  saveBrandDis(model, currentUser) {
    return this.http.post(this.appURL + 'saveBrandDis', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  saveiserviceoffered(company, items, currentUser) {
    return this.http.post(this.appURL + 'saveiserviceoffered', JSON.stringify({ company: company, items: items, currentUser: currentUser }));
  }

  savediscountoffer(company, items, currentUser) {
    return this.http.post(this.appURL + 'savediscountoffer', JSON.stringify({ company: company, items: items, currentUser: currentUser }));
  }

  saveMembership(company, items, currentUser) {
    return this.http.post(this.appURL + 'saveMembership', JSON.stringify({ company: company, items: items, currentUser: currentUser }));
  }

  savePack(company, items, currentUser) {
    return this.http.post(this.appURL + 'savePack', JSON.stringify({ company: company, items: items, currentUser: currentUser }));
  }

  savecoupon(company, items, currentUser) {
    return this.http.post(this.appURL + 'savecoupon', JSON.stringify({ company: company, items: items, currentUser: currentUser }));
  }

  getRetailDis(id, currentUser) {
    return this.http.post(this.appURL + 'getRetailDis', JSON.stringify({ id: id, currentUser: currentUser }));
  }

  checkPrice(item, currentUser) {
    return this.http.post(this.appURL + 'checkPrice', JSON.stringify({ item: item, currentUser: currentUser }));
  }

  checkPriceNew(item, currentUser) {
    return this.http.post(this.appURL + 'checkPriceNew', JSON.stringify({ item: item, currentUser: currentUser }));
  }

  checkPrice1(item, currentUser) {
    return this.http.post(this.appURL + 'checkPrice1', JSON.stringify({ item: item, currentUser: currentUser }));
  }


  getservicecategorysAddEdit(service_category_id, type, currentUser) {
    return this.http.post(this.appURL + 'getservicecategorysAddEdit',
      JSON.stringify({ service_category_id: service_category_id, type: type, currentUser: currentUser }));
  }

  getserviceofferedsAddEdit(service_offered_id, type, currentUser) {
    return this.http.post(this.appURL + 'getserviceofferedsAddEdit',
      JSON.stringify({ service_offered_id: service_offered_id, type: type, currentUser: currentUser }));
  }

  deletegridData(upId, upField, tableName, columnName) {
    return this.http.post(this.appURL + 'deletegridData',
      JSON.stringify({ upId: upId, upField: upField, tableName: tableName, columnName: columnName }));
  }

  deletegridDataNew(upId, upField, tableName, columnName, type) {
    return this.http.post(this.appURL + 'deletegridDataNew',
      JSON.stringify({ upId: upId, upField: upField, tableName: tableName, columnName: columnName, type: type }));
  }


  getInventoryItemterm(term, currentUser) {
    if (term === '') {
      return Observable.of([]);
    }
    return this.http.post(this.appURL + 'getInventoryItemterm', JSON.stringify({ search: term, currentUser: currentUser }));
  }

  getemployeeterm(term, tableName, currentUser) {
    return this.http.post(this.appURL + 'getemployeeterm', JSON.stringify({ search: term, tableName: tableName, currentUser: currentUser }))
      .map(response => <string[]>response['comp_details']);
  }

  getuintofmeasurement() {
    return this.http.get(this.appURL + 'getuintofmeasurement');
  }

  saveinventorymanager(company, type, checkedItems, inventory_manager_id, currentUser) {
    return this.http.post(this.appURL + 'saveinventorymanager', JSON.stringify({ currentUser: currentUser, company: company, type: type, checkedItems: checkedItems, inventory_manager_id: inventory_manager_id }));
  }

  saveServiceList(company, checkedItems, currentUser) {
    return this.http.post(this.appURL + 'saveServiceList', JSON.stringify({ company: company, checkedItems: checkedItems, currentUser: currentUser }));
  }

  saveemp(company, currentUser) {
    return this.http.post(this.appURL + 'saveemp', JSON.stringify({ company: company, currentUser: currentUser }));
  }

  savecus(company, currentUser, scheduler_id) {
    return this.http.post(this.appURL + 'savecus', JSON.stringify({ company: company, currentUser: currentUser, scheduler_id: scheduler_id }));
  }


  seprateMembership(company, currentUser) {
    return this.http.post(this.appURL + 'seprateMembership', JSON.stringify({ company: company, currentUser: currentUser }));
  }

  empList(company, currentUser) {
    return this.http.post(this.appURL + 'empList', JSON.stringify({ company: company, currentUser: currentUser }));
  }

  savescheduler(company, sch_emp, currentUser) {
    return this.http.post(this.appURL + 'savescheduler', JSON.stringify({ company: company, sch_emp: sch_emp, currentUser: currentUser }));
  }

  addEditcheckout(company, model, currentUser, type) {
    return this.http.post(this.appURL + 'addEditcheckout', JSON.stringify({ company: company, model: model, currentUser: currentUser, type: type }));
  }

  getcheckout(model, currentUser) {
    return this.http.post(this.appURL + 'getcheckout', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  getcheckoutNew(model, currentUser) {
    return this.http.post(this.appURL + 'getcheckoutNew', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  checkLimit(customer_id, service_offered_id, checkedItems, currentUser) {
    return this.http.post(this.appURL + 'checkLimit', JSON.stringify({ customer_id: customer_id, service_offered_id: service_offered_id, checkedItems: checkedItems, currentUser: currentUser }));
  }

  deleteoneitem(company, model, currentUser, type) {
    return this.http.post(this.appURL + 'deleteoneitem', JSON.stringify({ company: company, model: model, currentUser: currentUser, type: type }));
  }

  checkProduct_bulk(covenant, model, type, currentUser) {
    return this.http.post(this.appURL + 'checkProduct_bulk', JSON.stringify({ covenant: covenant, model: model, type: type, currentUser: currentUser }));
  }

  getServiceProduct(currentUser) {
    return this.http.post(this.appURL + 'getServiceProduct', JSON.stringify({ currentUser: currentUser }));
  }

  checkCheckouts(cus_id, currentUser) {
    return this.http.post(this.appURL + 'checkCheckouts', JSON.stringify({ cus_id: cus_id, currentUser }));
  }

  billing(productsTobuy, company, model, currentUser, discount, multiple_offer, product_multiple_offer, service_offered_id, selected_multiOffers, selected_ProductMultiOffers, varsercouponmultiple_offer, varprocouponproduct_multiple_offer, selectedProducts) {
    return this.http.post(this.appURL + 'billing', JSON.stringify({ productsTobuy: productsTobuy, company: company, model: model, currentUser: currentUser, discount: discount, multiple_offer: multiple_offer, product_multiple_offer: product_multiple_offer, service_offered_id: service_offered_id, selected_multiOffers: selected_multiOffers, selected_ProductMultiOffers: selected_ProductMultiOffers, varsercouponmultiple_offer: varsercouponmultiple_offer, varprocouponproduct_multiple_offer: varprocouponproduct_multiple_offer, selectedProducts: selectedProducts }));
  }

  saveCollectiveInventorySetup(model, currentUser) {
    return this.http.post(this.appURL + 'saveCollectiveInventorySetup', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  savePartnershipSetup(model, currentUser) {
    return this.http.post(this.appURL + 'savePartnershipSetup', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  saveInvoice(datas, tot_amt, invoiceTotal, multiple_offer, company, model, currentUser, discount, cgst, sgst) {
    return this.http.post(this.appURL + 'saveInvoice', JSON.stringify({ datas: datas, tot_amt: tot_amt, invoiceTotal: invoiceTotal, multiple_offer: multiple_offer, company: company, model: model, currentUser: currentUser, discount: discount, cgst: cgst, sgst: sgst }));
  }

  Addbrand(brand, currentUser) {
    return this.http.post(this.appURL + 'Addbrand', JSON.stringify({ brand: brand, currentUser: currentUser }));
  }

  getInventorymanager(inventory_item_id, currentUser) {
    return this.http.post(this.appURL + 'getInventorymanager',
      JSON.stringify({ inventory_item_id: inventory_item_id, currentUser: currentUser }));
  }

  checkCoupon(model, type, currentUser) {
    return this.http.post(this.appURL + 'checkCoupon',
      JSON.stringify({ model: model, type: type, currentUser: currentUser }));
  }

  checkCusNo(model, type, currentUser) {
    return this.http.post(this.appURL + 'checkCusNo',
      JSON.stringify({ model: model, type: type, currentUser: currentUser }));
  }

  getserviceList(service_list_id, currentUser) {
    return this.http.post(this.appURL + 'getserviceList',
      JSON.stringify({ service_list_id: service_list_id, currentUser: currentUser }));
  }

  getPartnership(partnership_id, currentUser) {
    return this.http.post(this.appURL + 'getPartnership',
      JSON.stringify({ partnership_id: partnership_id, currentUser: currentUser }));
  }

  getserviceListWithcategory(service_list_id, currentUser) {
    return this.http.post(this.appURL + 'getserviceListWithcategory',
      JSON.stringify({ service_list_id: service_list_id, currentUser: currentUser }));
  }

  getTemplatedetail(id, currentUser) {
    return this.http.post(this.appURL + 'getTemplatedetail',
      JSON.stringify({ id: id, currentUser: currentUser }));
  }

  saveTemplatedetail(model, currentUser) {
    return this.http.post(this.appURL + 'saveTemplatedetail',
      JSON.stringify({ model: model, currentUser: currentUser }));
  }

  getInventorymanagersAddEdit(inventory_manager_id, currentUser) {
    return this.http.post(this.appURL + 'getInventorymanagersAddEdit',
      JSON.stringify({ inventory_manager_id: inventory_manager_id, currentUser: currentUser }));
  }


  getserviceListAddEdit(service_list_id, currentUser) {
    return this.http.post(this.appURL + 'getserviceListAddEdit',
      JSON.stringify({ service_list_id: service_list_id, currentUser: currentUser }));
  }

  getcustomerschedulerAddEdit(scheduler_id, currentUser) {
    return this.http.post(this.appURL + 'getcustomerschedulerAddEdit',
      JSON.stringify({ scheduler_id: scheduler_id, currentUser: currentUser }));
  }

  deleteupload(upId, upField, tableName) {
    return this.http.post(this.appURL + 'deleteupload',
      JSON.stringify({ upId: upId, upField: upField, tableName: tableName }));
  }

  deleteReadingApp(upId, upField, tableName) {
    return this.http.post(this.appURL + 'deleteReadingApp',
      JSON.stringify({ upId: upId, upField: upField, tableName: tableName }));
  }


  deleteuploadEMP(upId, upField, tableName) {
    return this.http.post(this.appURL + 'deleteuploadEMP',
      JSON.stringify({ upId: upId, upField: upField, tableName: tableName }));
  }

  deletEMP(id) {
    return this.http.post(this.appURL + 'deletEMP',
      JSON.stringify({ id: id }));
  }

  getBrands(notall, currentUser) {
    return this.http.post(this.appURL + 'getBrands',
      JSON.stringify({ notall: notall, currentUser: currentUser }));
  }

  getBrandsDis(brand, currentUser) {
    return this.http.post(this.appURL + 'getBrandsDis',
      JSON.stringify({ brand: brand, currentUser: currentUser }));
  }

  getdesignations(notall) {
    return this.http.post(this.appURL + 'getdesignations',
      JSON.stringify({ notall: notall }));
  }

  getProducts(short_desc, currentUser) {
    return this.http.post(this.appURL + 'getProducts',
      JSON.stringify({ short_desc: short_desc, currentUser: currentUser }));
  }

  getPercent(currentUser) {
    return this.http.post(this.appURL + 'getPercent',
      JSON.stringify({ currentUser: currentUser }));
  }

  cusDetail(customer_id, currentUser) {
    return this.http.post(this.appURL + 'cusDetail',
      JSON.stringify({ customer_id: customer_id, currentUser: currentUser }));
  }


  savePercent(model, currentUser) {
    return this.http.post(this.appURL + 'savePercent',
      JSON.stringify({ model: model, currentUser: currentUser }));
  }

  deleteBrand(brand, currentUser) {
    return this.http.post(this.appURL + 'deleteBrand',
      JSON.stringify({ brand: brand, currentUser: currentUser }));
  }

  delCustomerCheckout(customer_id, currentUser) {
    return this.http.post(this.appURL + 'delCustomerCheckout',
      JSON.stringify({ customer_id: customer_id, currentUser: currentUser }));
  }

  checkItemquantity(item, inventory_manager_id, currentUser) {
    return this.http.post(this.appURL + 'checkItemquantity',
      JSON.stringify({ item: item, inventory_manager_id_main_id: inventory_manager_id, currentUser: currentUser }));
  }

  checkItemquantity2(item, service_list_id, currentUser) {
    return this.http.post(this.appURL + 'checkItemquantity2',
      JSON.stringify({ item: item, service_list_id: service_list_id, currentUser: currentUser }));
  }

  checkItemquantityExist(item, service_list_id, currentUser) {
    return this.http.post(this.appURL + 'checkItemquantityExist',
      JSON.stringify({ item: item, service_list_id: service_list_id, currentUser: currentUser }));
  }

  dynamicReport(model, currentUser) {
    return this.http.post(this.appURL + 'dynamicReport', JSON.stringify({ model: model, currentUser: currentUser }));
  }

  deletePastCheckouts(salon_id) {
    return this.http.post(this.appURL + 'deletePastCheckouts', JSON.stringify({ salon_id: salon_id }));
  }


  getSMSTemplateTransactional() {
    return this.http.get(this.SMSTemplateTransactional);
  }

  getTransactionalSMSReport() {
    return this.http.get(this.getSMSReport);
  }

  getPromotionalSMSReport(data) {
    return this.http.post(this.appURL + 'getPromotionalSMSReport', JSON.stringify({ data: data }));
  }

  getWhatsAppTemplate(data, currentUser) {
    return this.http.post(this.appURL + 'getWhatsAppTemplate', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getmetaWhatsAppCredential(currentUser) {
    return this.http.post(this.appURL + 'getmetaWhatsAppCredential', JSON.stringify({ currentUser: currentUser }));
  }

  getSMSTemplatePromotional() {
    return this.http.get(this.SMSTemplatePromotional);
  }

  saveSMSTemplateTransactional(data, currentUser) {
    return this.http.post(this.appURL + 'saveSMSTemplateTransactional', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  saveTransactionalSMSReport(data, currentUser) {
    return this.http.post(this.appURL + 'saveTransactionalSMSReport', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  setreadyToSend(data, value, type, currentUser) {
    return this.http.post(this.appURL + 'setreadyToSend', JSON.stringify({ data: data, value: value, type: type, currentUser: currentUser }));
  }

  getSMSTemplateTransactionalSearch(data, currentUser) {
    return this.http.post(this.appURL + 'getSMSTemplateTransactionalSearch', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getTransactionalSMSReportSearch(data, currentUser) {
    return this.http.post(this.appURL + 'getTransactionalSMSReportSearch', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  full_bill(bill_no, currentUser) {
    return this.http.post(this.appURL + 'full_bill', JSON.stringify({ bill_no: bill_no, currentUser }));
  }

  senSMS(data) {
    return this.http.post('http://smsssl.dial4sms.com/api/v2/SendSMS', JSON.stringify({ SenderId: 'KALLCA', 'Is_Unicode': false, "Is_Flash": false, Message: 'Dear gokul,  Thank you for visiting The Kallos Care Unisex Salon We hope you enjoyed it! For your next visit Call: 9087766771 Map:http://surl.li/htthlk', MobileNumbers: 'KALLCA', TemplateId: 1107172051335754005, ApiKey: 'm68fHxp8/qmNZy3nn9To7acJHr54p6cD2wXS8LTa13E=', ClientId: '46ffffc2-a86d-495c-841b-ad498433f417' }));
  }

  dateChange(billed_on, bill_no, currentUser) {
    return this.http.post(this.appURL + 'dateChange', JSON.stringify({ billed_on: billed_on, bill_no: bill_no, currentUser: currentUser }));
  }

  packdateChange(pack, currentUser) {
    return this.http.post(this.appURL + 'packdateChange', JSON.stringify({ pack: pack, currentUser: currentUser }));
  }

  savepaymentMode(model, bill_no, currentUser) {
    return this.http.post(this.appURL + 'savepaymentMode', JSON.stringify({ model: model, bill_no: bill_no, currentUser: currentUser }));
  }

  savepaymentModeWallet(model, bill_no, currentUser) {
    return this.http.post(this.appURL + 'savepaymentModeWallet', JSON.stringify({ model: model, bill_no: bill_no, currentUser: currentUser }));
  }

  saveBill(base64Image, bill_no, currentUser) {
    return this.http.post(this.appURL + 'saveBill', JSON.stringify({ base64Image: base64Image, bill_no: bill_no, currentUser: currentUser }));
  }

  getMemDetail(customer_id, currentUser) {
    return this.http.post(this.appURL + 'getMemDetail', JSON.stringify({ customer_id: customer_id, currentUser: currentUser }));
  }

  getCollectiveIncentiveSetup(currentUser) {
    return this.http.post(this.appURL + 'getCollectiveIncentiveSetup',
      JSON.stringify({ currentUser: currentUser }));
  }

  changestatus(list, currentUser) {
    return this.http.post(this.appURL + 'changestatus', JSON.stringify({ list: list, currentUser: currentUser }));
  }

  getUserId(userId, currentUser) {
    return this.http.post(this.appURL + 'getUserId', JSON.stringify({ userId: userId, currentUser: currentUser }));
  }

  getUsers(currentUser) {
    return this.http.post(this.appURL + 'getUsers', JSON.stringify({ currentUser: currentUser }));
  }

  getModules(currentUser) {
    return this.http.post(this.appURL + 'getModules', JSON.stringify({ currentUser: currentUser }));
  }

  saveAccess(payload) {
    return this.http.post(this.appURL + 'saveAccess', JSON.stringify({ payload: payload }));
  }

  uploadBulkData(formData: FormData) {
    return this.http.post(this.appURL + 'upload_endpoint.php', formData);
  }


  // Attendance Management Methods
  getEmployeesForAttendance(currentUser) {
    return this.http.post(this.appURL + 'getEmployeesForAttendance', JSON.stringify({ currentUser: currentUser }));
  }

  getDailyAttendance(data: any) {
    return this.http.post(this.appURL + 'getDailyAttendance', JSON.stringify(data));
  }

  markAttendance(data: any) {
    return this.http.post(this.appURL + 'markAttendance', JSON.stringify(data));
  }

  saveEmployeeRoster(rosterData: any) {
    return this.http.post(this.appURL + 'saveEmployeeRoster', JSON.stringify(rosterData));
  }

  getEmployeeRoster(employee_id: any) {
    return this.http.post(this.appURL + 'getEmployeeRoster', JSON.stringify(employee_id));
  }

  getWeeklyRoster(payload: any) {
    return this.http.post(this.appURL + 'getWeeklyRoster', JSON.stringify(payload));
  }

  saveWeeklyRoster(payload: any) {
    return this.http.post(this.appURL + 'saveWeeklyRoster', JSON.stringify(payload));
  }

  getEmployeeMonthData(employee_id: any, month: any, currentUser) {
    return this.http.post(this.appURL + 'getEmployeeMonthData', JSON.stringify({ employee_id, month, currentUser: currentUser }));
  }

  getEmployeeMonthlyRoster(employee_id: any, month: any, currentUser) {
    return this.http.post(this.appURL + "getEmployeeMonthlyRoster",
      JSON.stringify({ employee_id, month, currentUser: currentUser })
    );
  }

  getRosterByDate(data: any) {
    return this.http.post(this.appURL + 'getRosterByDate', JSON.stringify(data));
  }

  getTotals(data: any) {
    return this.http.post(this.appURL + 'getTotals', JSON.stringify(data));
  }

  getCustomerCompl(currentUser) {
    return this.http.post(this.appURL + 'getCustomerCompl', JSON.stringify({ currentUser: currentUser }));
  }

  getPackageMembershipInvoiceReport(data, currentUser) {
    return this.http.post(this.appURL + 'getPackageMembershipInvoiceReport', JSON.stringify({ data: data, currentUser: currentUser }));
  }

  savePackagepaymentMode(pack, currentUser) {
    return this.http.post(this.appURL + 'savePackagepaymentMode', JSON.stringify({ pack: pack, currentUser: currentUser }));
  }

  sendPackageDetails(base64Image, id, currentUser) {
    return this.http.post(this.appURL + 'sendPackageDetails', JSON.stringify({ base64Image: base64Image, id: id, currentUser: currentUser }));
  }

  stringToDate(str: string) {
    const parts = str.split('-');  // ["YYYY","MM","DD"]
    const year = parts[0];
    // Remove leading zeros (same as ltrim in PHP)
    const month = parts[1].replace(/^0+/, '') || parts[1];
    const day = parts[2].replace(/^0+/, '') || parts[2];
    return {
      year: year,
      month: month,
      day: day,
      date: {
        year: year,
        month: month,
        day: day
      }
    };
  }

  // Salon Management Methods
  getSalons(type, currentUser: any) {
    return this.http.post(this.appURL + 'getSalons', JSON.stringify({ type: type, currentUser: currentUser }));
  }

  // In login.service.ts
  getManageableSalons(currentUser: any) {
    return this.http.post(this.appURL + 'getManageableSalons', JSON.stringify({ currentUser: currentUser }));
  }

  getSalonDetails(salonId: string, currentUser: any) {
    return this.http.post(this.appURL + 'getSalonDetails', JSON.stringify({ salon_id: salonId, currentUser: currentUser }));
  }

  getSalonUsers(salonId: number, currentUser: any) {
    return this.http.post(this.appURL + 'getSalonUsers', JSON.stringify({ salon_id: salonId, currentUser: currentUser }));
  }

  saveSalon(salonData: any, currentUser: any) {
    return this.http.post(this.appURL + 'saveSalon', JSON.stringify({ salon: salonData, currentUser: currentUser }));
  }

  saveSalonUsers(salonId: number, users: any[], currentUser: any) {
    return this.http.post(this.appURL + 'saveSalonUsers', JSON.stringify({ salon_id: salonId, users: users, currentUser: currentUser }));
  }

  getSalonDropdown(currentUser: any) {
    return this.http.post(this.appURL + 'getSalonDropdown', JSON.stringify({ currentUser: currentUser }));
  }

  deleteSalon(salonId: number, currentUser: any) {
    return this.http.post(this.appURL + 'deleteSalon', JSON.stringify({ salon_id: salonId, currentUser: currentUser }));
  }

  CheckUsername(userModel: any) {
    return this.http.post(this.appURL + 'CheckUsername', JSON.stringify({ userModel: userModel }));
  }

  deleteUser(user_id: any) {
    return this.http.post(this.appURL + 'deleteUser', JSON.stringify({ user_id: user_id }));
  }

  switchSalon(salonId: number, currentUser: any) {
    return this.http.post(this.appURL + 'switchSalon', JSON.stringify({ salon_id: salonId, currentUser: currentUser }));
  }

  sendPasswordResetOTP(username) {
    return this.http.post(this.appURL + 'sendPasswordResetOTP', JSON.stringify({ username: username }));
  }

  verifyPasswordResetOTP(user_id, otp) {
    return this.http.post(this.appURL + 'verifyPasswordResetOTP', JSON.stringify({ user_id: user_id, otp: otp }));
  }

  resetPasswordWithOTP(otp_token, password) {
    return this.http.post(this.appURL + 'resetPasswordWithOTP', JSON.stringify({ otp_token: otp_token, password: password }));
  }

  getWhatsAppTemplateFromMeta() {
    return this.http.get('https://graph.facebook.com/v22.0/25337322265962304/message_templates');
  }

  getWhatsAppStoredTemplateFromMeta(currentUser, APPROVED) {
    return this.http.post(this.appURL + 'getWhatsAppStoredTemplateFromMeta', JSON.stringify({ currentUser: currentUser, APPROVED: APPROVED }));
  }

  submitMetaTemplate(templateData: any, currentUser: any) {
    return this.http.post(this.appURL + 'submitMetaTemplate', JSON.stringify({ templateData: templateData, currentUser: currentUser }));
  }

  sendBulkWhatsApp(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.appURL + 'sendBulkWhatsApp', formData);
  }

  send_whatsapp(selectedTemplate, mobileNumber, variables, currentUser, headerImageUrl = '') {
    return this.http.post(this.appURL + 'send_whatsapp', JSON.stringify({
      selectedTemplate: selectedTemplate,
      mobileNumber: mobileNumber,
      variables: variables,
      currentUser: currentUser,
      headerImageUrl: headerImageUrl
    }));
  }

  changeAmount(selectedItem, currentUser) {
    return this.http.post(this.appURL + 'changeAmount',
      JSON.stringify({ selectedItem: selectedItem, currentUser: currentUser }));
  }

  refundMembership(data, currentUser) {
    return this.http.post(this.appURL + 'refundMembership',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  uploadSalonLogo(formData: FormData, type?: string) {
    const page = type === 'billLogo' ? 'billLogo' : 'salon_logo';
    return this.http.post(this.uploadURL + `upload.php?page=${page}`, formData);
  }

  uploadBulkCustomers(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.appURL + 'uploadBulkCustomers', formData);
  }

  uploadServiceCategory(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.appURL + 'uploadServiceCategory', formData);
  }

  uploadServiceList(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.appURL + 'uploadServiceList', formData);
  }

  uploadServiceMapping(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.appURL + 'uploadServiceMapping', formData);
  }

  getAllhow(currentUser) {
    return this.http.post(this.appURL + 'getAllhow',
      JSON.stringify({ currentUser: currentUser }));
  }

  deleteHow(how, currentUser) {
    return this.http.post(this.appURL + 'deleteHow',
      JSON.stringify({ how: how, currentUser: currentUser }));
  }

  Addhow(how, currentUser) {
    return this.http.post(this.appURL + 'Addhow', JSON.stringify({ how: how, currentUser: currentUser }));
  }


  getAllstock_location(currentUser) {
    return this.http.post(this.appURL + 'getAllstock_location',
      JSON.stringify({ currentUser: currentUser }));
  }

  deleteStockLocation(stock_location, currentUser) {
    return this.http.post(this.appURL + 'deleteStockLocation',
      JSON.stringify({ stock_location: stock_location, currentUser: currentUser }));
  }

  Addstock_location(stock_location, currentUser) {
    return this.http.post(this.appURL + 'Addstock_location', JSON.stringify({ stock_location: stock_location, currentUser: currentUser }));
  }

  getAllstock_area(currentUser) {
    return this.http.post(this.appURL + 'getAllstock_area',
      JSON.stringify({ currentUser: currentUser }));
  }


  deleteStockArea(stock_area, currentUser) {
    return this.http.post(this.appURL + 'deleteStockArea',
      JSON.stringify({ stock_area: stock_area, currentUser: currentUser }));
  }

  Addstock_area(stock_area, currentUser) {
    return this.http.post(this.appURL + 'Addstock_area', JSON.stringify({ stock_area: stock_area, currentUser: currentUser }));
  }

  checkExtraProd(data, currentUser) {
    return this.http.post(this.appURL + 'checkExtraProd',
      JSON.stringify({ data: data, currentUser: currentUser }));
  }

  getAvailProducts(short_desc, currentUser) {
    return this.http.post(this.appURL + 'getAvailProducts',
      JSON.stringify({ short_desc: short_desc, currentUser: currentUser }));
  }

  updateMembership(currentDateTime, currentDate, currentUser) {
    return this.http.post(this.appURL + 'updateMembership',
      JSON.stringify({ currentDateTime: currentDateTime, currentDate: currentDate, currentUser: currentUser }));
  }

  // uploadWhatsAppImage(formData: FormData, currentUser: any): Observable<any> {
  //   formData.append('currentUser', JSON.stringify(currentUser));
  //   return this.http.post(`${this.appURL}uploadWhatsAppImage`, formData, {
  //     reportProgress: true,
  //     observe: 'events'
  //   }).pipe(
  //     map((event: HttpEvent<any>) => {
  //       switch (event.type) {
  //         case HttpEventType.UploadProgress:
  //           const progress = Math.round(100 * event.loaded / event.total!);
  //           return { type: 'progress', progress: progress };
  //         case HttpEventType.Response:
  //           return { type: 'response', data: event.body };
  //         default:
  //           return event;
  //       }
  //     })
  //   );
  // }

  // uploadWhatsAppImage(formData: FormData, currentUser: any) {
  //   formData.append('currentUser', JSON.stringify(currentUser));
  //   return this.http.post(this.appURL + 'uploadWhatsAppImage', formData);
  // }

  uploadWhatsAppImage(formData: FormData, currentUser: any) {
    formData.append('currentUser', JSON.stringify(currentUser));
    return this.http.post(this.uploadURL + 'upload.php?page=whatsapp_image', formData);
  }

  recharge(addCredits, currentUser) {
    return this.http.post(this.appURL + 'recharge',
      JSON.stringify({ addCredits: addCredits, currentUser: currentUser }));
  }

  getCreditsHistory(currentUser) {
    return this.http.post(this.appURL + 'getCreditsHistory',
      JSON.stringify({ currentUser: currentUser }));
  }

  deleteInvoice(bill_no, currentUser) {
    return this.http.post(this.appURL + 'deleteInvoice',
      JSON.stringify({ bill_no: bill_no, currentUser: currentUser }));
  }

}



// WEBPACK FOOTER //
// ./src/app/login.service.ts